import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import NetworkCanvas from "@/components/NetworkCanvas";

/**
 * Reusable page hero for inner pages — smaller height, breadcrumb + headline.
 */
const PageHero = ({ eyebrow, title, sub, breadcrumb = [], testId = "page-hero" }) => {
  return (
    <section
      data-testid={testId}
      className="relative dark-section overflow-hidden pt-[120px] lg:pt-[140px] pb-20 lg:pb-28"
    >
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-dot-grid opacity-40" />
        <NetworkCanvas />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(9,10,15,0.4) 0%, rgba(9,10,15,0.85) 70%, #090a0f 100%)",
          }}
        />
      </div>

      <div className="relative z-10 max-w-[1380px] mx-auto px-6 lg:px-10">
        {breadcrumb.length > 0 && (
          <nav className="flex items-center gap-2 mb-10" aria-label="Breadcrumb">
            {breadcrumb.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                {b.to ? (
                  <Link
                    to={b.to}
                    className="font-mono text-[11px] tracking-[0.22em] uppercase text-white/50 hover:text-white"
                  >
                    {b.label}
                  </Link>
                ) : (
                  <span className="font-mono text-[11px] tracking-[0.22em] uppercase text-white">
                    {b.label}
                  </span>
                )}
                {i < breadcrumb.length - 1 && (
                  <span className="font-mono text-[11px] text-white/30">/</span>
                )}
              </span>
            ))}
          </nav>
        )}

        <span className="kicker">
          <span className="w-1.5 h-1.5 rounded-full bg-[#00e5ff]" />
          {eyebrow}
        </span>

        <h1
          data-testid={`${testId}-title`}
          className="mt-6 font-display font-bold text-white tracking-tight leading-[1.02] text-[42px] sm:text-[60px] lg:text-[80px] max-w-[18ch]"
        >
          {title}
        </h1>

        {sub && (
          <p className="mt-7 text-white/65 text-[17px] sm:text-[19px] leading-relaxed max-w-[60ch]">
            {sub}
          </p>
        )}

        <div className="mt-10 flex flex-wrap gap-3">
          <a
            href="/get-started?type=diagnostic"
            data-testid={`${testId}-cta`}
            className="btn-primary"
          >
            Book a diagnostic <ArrowUpRight className="w-4 h-4" />
          </a>
          <Link to="/contact" data-testid={`${testId}-cta-contact`} className="btn-ghost-dark">
            Talk to the team
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PageHero;
